import React from 'react';
import SingleSelect from './SingleSelect';

const SelectContainer = ({ list }) => {
  return (
    <div className="general-options-wrap">
    {
      list.map(item => {
        return (
          <SingleSelect
            key={item.id}
            {...item}
          />
        )
      })
    }
  </div>
  )
}

export default SelectContainer;